/**
 * @generated SignedSource<<e4cefd751bb1eeedb82b3ec5288d6b36>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "firstName"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "lastName"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "legalContractName"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "locationName"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "npi"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "tin"
  }
],
v1 = {
  "kind": "Variable",
  "name": "firstName",
  "variableName": "firstName"
},
v2 = {
  "kind": "Variable",
  "name": "lastName",
  "variableName": "lastName"
},
v3 = {
  "kind": "Variable",
  "name": "legalContractName",
  "variableName": "legalContractName"
},
v4 = {
  "kind": "Variable",
  "name": "locationName",
  "variableName": "locationName"
},
v5 = {
  "kind": "Variable",
  "name": "npi",
  "variableName": "npi"
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PractitionersTableRefetch",
    "selections": [
      {
        "args": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "kind": "Variable",
            "name": "tin",
            "variableName": "tin"
          }
        ],
        "kind": "FragmentSpread",
        "name": "PractitionersTableFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PractitionersTableRefetch",
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "fields": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "kind": "Variable",
                "name": "tIN",
                "variableName": "tin"
              }
            ],
            "kind": "ObjectValue",
            "name": "input"
          }
        ],
        "concreteType": "Practitioner",
        "kind": "LinkedField",
        "name": "filteredPractitioners",
        "plural": true,
        "selections": [
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "LegalContract",
            "kind": "LinkedField",
            "name": "legalContract",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PractitionerIdentifier",
            "kind": "LinkedField",
            "name": "identifiers",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "IdentifierType",
                "kind": "LinkedField",
                "name": "identifierType",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "value",
                "storageKey": null
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PractitionerVersion",
            "kind": "LinkedField",
            "name": "applicableVersion",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displayName",
                "storageKey": null
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9985e9d8ccbde265f96924f7fb757107",
    "id": null,
    "metadata": {},
    "name": "PractitionersTableRefetch",
    "operationKind": "query",
    "text": "query PractitionersTableRefetch(\n  $firstName: String = null\n  $lastName: String = null\n  $legalContractName: String = null\n  $locationName: String = null\n  $npi: String = null\n  $tin: String = null\n) {\n  ...PractitionersTableFragment_3GgIGS\n}\n\nfragment PractitionersTableFragment_3GgIGS on Query {\n  filteredPractitioners(input: {firstName: $firstName, lastName: $lastName, npi: $npi, tIN: $tin, legalContractName: $legalContractName, locationName: $locationName}) {\n    id\n    legalContract {\n      id\n      name\n    }\n    identifiers {\n      identifierType {\n        code\n        id\n      }\n      value\n      id\n    }\n    applicableVersion {\n      displayName\n      id\n    }\n  }\n}\n"
  }
};
})();

node.hash = "e4ceb9874de313228b70f9a2da085fac";

export default node;
